import React, { useEffect, useState, useCallback } from 'react'
import './PhoneInput.scss'
import { RiCheckFill, RiPencilFill } from 'react-icons/ri'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import { FaTimes } from 'react-icons/fa'
import Grid from '@mui/material/Grid'

const PhoneInput = React.memo(({ phone, setEntity, label, fieldName, error }) => {
  const [showCaption, setShowCaption] = useState(true)
  const [caption, setCaption] = useState('')

  useEffect(() => {
    if (phone) {
      setCaption(phone)
    }
  }, [phone])

  const saveCaption = useCallback(() => {
    setShowCaption(true)
    setEntity((departmentInfoEntity) => ({
      ...departmentInfoEntity,
      [fieldName]: caption
    }))
  }, [caption, fieldName, setEntity])

  const discardCaption = useCallback(() => {
    setCaption(phone)
    setShowCaption(true)
  }, [phone])

  const handleCaptionChange = useCallback(
    (evt) => {
      // Numbers only
      const value = evt.target.value.replace(/\D/, '')
      setCaption(value)
    },
    [setCaption]
  )

  return (
    <>
      <Grid size={5} className="container-field">
        <label htmlFor="phoneNumber">{label}</label>
        <br />
        <label htmlFor="error" className="error-text">
          {error}
        </label>
        <br />
        {showCaption ? (
          <div className="caption-container-display">
            <Tooltip title={caption} placement="top" arrow>
              <a href={'tel:' + phone} data-title={caption}>
                {caption}
              </a>
            </Tooltip>
            <RiPencilFill className="edit-icon" onClick={() => setShowCaption(false)} />
          </div>
        ) : (
          <div className="caption-input-container">
            <TextField
              id="phoneNumber"
              name="phoneNumber"
              multiline
              rows={2}
              variant="outlined"
              className="form-control"
              value={caption || ''}
              onChange={handleCaptionChange}
            />
            <div className="caption-controls-container">
              <RiCheckFill className="save-caption" onClick={saveCaption} />
              <FaTimes className="discard-caption" onClick={discardCaption} />
            </div>
          </div>
        )}
      </Grid>
    </>
  )
})

export default PhoneInput
